"use client"
/* */
import { Generator } from '@mittwald/password-tools-js/generator';

const generatePassword = async (validationPolicy) => {
  return new Generator(validationPolicy).generatePassword();
};

export { generatePassword };
//# sourceMappingURL=generatePassword.mjs.map
